import { UserType } from '../../entities/tenant/user.type';
import { AppSecurityRight } from '../modules/app.security';
import { ClaimSecurityModule, ClaimSecurityRight } from '../modules/claim.security.module';
import { ConfigurationSecurityRight } from '../modules/configuration.security.module';
import { withDerivedCrmRecordRights } from '../modules/crm.record.rights';
import { CrmSecurityModule, CrmSecurityRight } from '../modules/crm.security.module';
import { DashboardSecurityRight } from '../modules/dashboard.security.module';
import { FinanceSecurityModule, FinanceSecurityRight } from '../modules/finance.security.module';
import { JobSecurityModule, JobSecurityRight } from '../modules/job.security.module';
import { withDerivedJobSectionRights } from '../modules/job.section.rights';
import { TimesheetSecurityModule } from '../modules/timesheet.security.module';
import { VariationSecurityModule } from '../modules/variation.security.module';
import { SecurityRole, SecurityRoleType } from '../security.role';


export class EmployeeFinance implements SecurityRole {

    _id = '0673fa47-c26a-4dc5-a989-847e3e331920';
    system = true;
    hidden = false;
    name = SecurityRoleType.EmployeeFinance;
    type = UserType.Employee;
    description = 'Can manage customers, manage jobs, manage quotes and generate invoices';
    rights = withDerivedCrmRecordRights(withDerivedJobSectionRights([
        AppSecurityRight.LoginWeb,

        ConfigurationSecurityRight.AccessMetadata,
        ConfigurationSecurityRight.AccessPricing,
        ConfigurationSecurityRight.AccessTenancy,

        ConfigurationSecurityRight.ManageMetadata,
        ConfigurationSecurityRight.ManagePricing,
        ConfigurationSecurityRight.ManageTenancy,

        ConfigurationSecurityRight.AccessTemplates,
        ConfigurationSecurityRight.AccessDocumentThemes,
        ConfigurationSecurityRight.ManageDocumentThemes,

        // MarkFinanceLock excluded: marking a job or stage Non-Billable / Non-Payable zeroes every line
        // under it, so it ships granted to no seeded role and a consultant enables it per role.
        // ChangeJobStructure excluded: a job's structure decides its stages and scheduling, so only an
        // administrator overrides or converts it by default and a consultant enables it per role.
        ...new JobSecurityModule().allExceptRights([JobSecurityRight.ReverseWorkOrderStatus, JobSecurityRight.AccessQuote, JobSecurityRight.ManageQuote, JobSecurityRight.MarkFinanceLock, JobSecurityRight.ApprovePendingItems, JobSecurityRight.ChangeJobStructure, JobSecurityRight.CompleteStagesWithUnresolvedTasks]),
        ...new FinanceSecurityModule().allExceptRights([FinanceSecurityRight.ManageApprovedInvoices, FinanceSecurityRight.ManageApprovedBills]),
        ...new CrmSecurityModule().allExceptRights([CrmSecurityRight.ManageSecurityRoles, CrmSecurityRight.ViewRecurringJobsWithinCustomers, CrmSecurityRight.ViewRecurringJobsWithinSites, CrmSecurityRight.ViewServicesWithinSites]),
        ...new VariationSecurityModule().allRights,
        ...new ClaimSecurityModule().allExceptRights([ClaimSecurityRight.ApproveClaimsWithUnresolvedTasks, ClaimSecurityRight.RejectClaims]),
        ...new TimesheetSecurityModule().allRights,

        // DashboardSecurityRight.CanViewSystemDashboards,
        DashboardSecurityRight.CanCreateDashboards,
    ]));

}

